import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "quoting", spoke: "quoting", title: "Quoting", icon: RequestQuoteIcon, order: 35, entries: [
  { label: "RFQ workspace", to: "/app/quoting/rfqs", permission: "quoting.rfq.view" },
  { label: "Quotes", to: "/app/quoting/quotes", permission: "quoting.quote.view" },
  { label: "Estimator", to: "/app/quoting/estimator", permission: "quoting.estimating.view" },
  { label: "Price rules", to: "/app/masterdata/price-rules", permission: "quoting.pricing.view" },
  { label: "Material prices", to: "/app/masterdata/material-prices", permission: "quoting.estimating.view" },
  { label: "Stock forms", to: "/app/masterdata/stock-forms", permission: "quoting.stock_form.view" },
] });
